import ContentContainer from 'general/components/ContentContainer'
import { useCallback, useState } from 'react'
import ButtonGroupTab from 'general/components/Tab'
import { SummaryReport } from './Components/SummaryReport'
import { FullColumnReport } from './Components/FullColumnReport'
import useFilter from 'hooks/useFilter'
import { useGetInvoiceBVPSStatistic } from './queries'
import { useGetInvoiceStatistic } from '../UsedInvoiceStatisticScreen/queries'
import useSearchDebounce from 'hooks/useSearchDebounce'

function BVPSReportScreen() {
  const [currentTab, setCurrentTab] = useState(0)
  // summary report
  const [filters, setFilters] = useFilter(
    'BVPSSummaryInvoiceList',
    'gFiltersBVPSSummaryInvoices',
  )
  const { data: usedInvoiceStatistic, isFetching } =
    useGetInvoiceBVPSStatistic(filters)
  console.log({ usedInvoiceStatistic })
  // end summary report

  // begin full column report
  const { debouncedSearch, search, setSearch } = useSearchDebounce('')
  const [filterFullColumn, setFilterFullColumn] = useFilter(
    'BVPSInvoiceList',
    'gFiltersBVPSInvoices',
  )
  const attributes = [
    'serial',
    'no',
    'date',
    'accountId',
    'patientCode',
    'customerCompanyName',
    'totalAfterTax',
    'lookupCode',
    'issueStatus',
  ]

  const { data, isFetching: isFetchingFullColumn } = useGetInvoiceStatistic(
    debouncedSearch,
    { ...filterFullColumn, attributes, isGetTotal: true },
  )
  // end full column report

  return (
    <ContentContainer>
      <ButtonGroupTab
        textButton1={'Báo cáo tổng quát'}
        textButton2={'Báo cáo chi tiết'}
        setCurrentTab={setCurrentTab}
        currentTab={currentTab}
        buttonWidth="220px"
        styles={{ margin: '0 auto', marginTop: '10px' }}
      />
      {currentTab === 0 ? (
        <SummaryReport
          filters={filters}
          setFilters={setFilters}
          data={usedInvoiceStatistic}
          isFetching={isFetching}
        />
      ) : (
        <FullColumnReport
          filters={filterFullColumn}
          setFilters={setFilterFullColumn}
          data={data}
          isFetching={isFetchingFullColumn}
          debouncedSearch={debouncedSearch}
          search={search}
          setSearch={setSearch}
        />
      )}
    </ContentContainer>
  )
}

export default BVPSReportScreen
